import {makeAutoObservable} from 'mobx';
import {Title} from '../../entity/model/title';
import TitleAgent from '../agent/title-agent';
import {PageOption} from '../../entity/enums/page-option';
import {RequestBody} from '../../entity/core/request-body';
import {ReviewStatus} from '../../entity/enums/review-status';

export default class TitleStore {
  selectedTitle: Title | undefined;
  titleAgent: TitleAgent;
  pageOption: PageOption = PageOption.DOCUMENTS;
  loading: boolean = false;
  cache: boolean = false;
  refreshTitleDetails: boolean = false;

  constructor(titleAgent: TitleAgent) {
    makeAutoObservable(this);
    this.titleAgent = titleAgent;
  }

  getTitles = async (organizationId: string, projectId: string): Promise<Title[]> => {
    try {
      return await this.titleAgent.getTitles(organizationId, projectId);
    } catch (error: any) {
      console.error('Error occurred while fetching the titles', error);
    }

    return [];
  }

  getTitleById = async (organizationId: string, titleId: string): Promise<Title | undefined> => {
    try {
      this.loading = true;
      this.selectedTitle = await this.titleAgent.getTitleById(organizationId, titleId);
      this.cache = true;
      this.loading = false;
    } catch (error: any) {
      console.error('Error occurred while fetch the title', error);
    }

    return this.selectedTitle;
  }

  addNewSection = async (organizationId: string, titleId: string, requestBody: RequestBody): Promise<Title | string> => {
    try {
      this.loading = true;
      this.selectedTitle = await this.titleAgent.addNewSection(organizationId, titleId, requestBody);
      this.cache = true;
      this.loading = false;
    } catch (error: any) {
      console.error('Error occurred while add new section', error);
      return 'Error occurred while add new section !!';
    }

    return this.selectedTitle;
  }

  addComment = async (organizationId: string, titleId: string, requestBody: RequestBody): Promise<string | Title> => {
    try {
      return await this.titleAgent.addComment(organizationId, titleId, requestBody);
    } catch (error: any) {
      console.error('Error occurred while adding the comment', error);
      return 'Error occurred while adding the comment !!';
    }
  }

  submitTitle = async (organizationId: string, titleId: string): Promise<string | Title> => {
    try {
      return await this.titleAgent.submitTitle(organizationId, titleId);
    } catch (error: any) {
      console.error('Error occurred while submitting the title', error);
      return 'Error occurred while submitting the title !!';
    }
  }

  reviewTitle = async (organizationId: string, titleId: string, reviewStatus: ReviewStatus): Promise<string | Title> => {
    try {
      return await this.titleAgent.reviewTitle(organizationId, titleId, reviewStatus);
    } catch (error: any) {
      console.error('Error occurred while reviewing the title', error);
      return 'Error occurred while reviewing the title !!';
    }
  }

  approveTitle = async (organizationId: string, titleId: string, reviewStatus: ReviewStatus): Promise<string | Title> => {
    try {
      return  await this.titleAgent.approveTitle(organizationId, titleId, reviewStatus);
    } catch (error: any) {
      console.error('Error occurred while approving the title', error);
      return 'Error occurred while approving the title !!';
    }
  }
}
